import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app/core/providers/forms/common.service';
import { Numbers } from 'src/app/utils/constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  currentForm: number = Numbers.number1;
  showLogoBroker = false;
  urlLogoBroker = '';
  urlCompleta: string = window.location.href;

  @Input() urlLogoCorredor: any;

  /**
   * @description constructor
   * @params commons
   */
  constructor(
    private commons: CommonService) {
      this.commons = commons;
  }
  /**
   * @description Metodo de inicio
   */
  ngOnInit() {
    this.currentForm = this.commons.setForm();
    if (this.urlLogoCorredor !== undefined && this.urlLogoCorredor !== '') {
      this.showLogoBroker = true;
      this.urlLogoBroker = this.urlLogoCorredor;
    } else {
      this.showLogoBroker = false;
      this.urlLogoBroker = '';
    }

  }

  /**
   * @description Redirect to the
   */
  redirectHome(): void {
    if (this.urlCompleta.includes('local')) { // LOCAL

     } else if (this.urlCompleta.includes('pua-dev')) { // DEV

      window.location.href = 'http://pua-dev.oci.santalucia.net:6680/home-pua';

     } else if (this.urlCompleta.includes('tst.iris') || this.urlCompleta.includes('10.60.4.162')) { // TEST

      window.location.href = 'https://wwwtst.irisglobal.es/home-pua';

     } else if (this.urlCompleta.includes('10.60.5.130')) { // PRE

      window.location.href = 'http://10.60.5.130:6680/home';

     } else if (this.urlCompleta.includes('www.irisglobal')) { // PRO

      window.location.href = 'https://www.irisglobal.es/home';

     } else {}
  }
}
